import {useConnectionStore} from "~/stores/connection";

export const submitFeedback = (feedback: string, activeUrl: string, screenshotDataUrl?: string) => {
    return useConnectionStore().execute('feedback/submit', {
        feedback, activeUrl, screenshotDataUrl: screenshotDataUrl ?? ''
    })
}